import Vue from 'vue';
import Vuex from 'vuex';
import { state } from './state';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';

//Modules
import authorization from "./authorization";
import files from "./files";
import users from "./users";
import recipients from "./recipients";
import sms from "./sms";
import promotions from "./promotions";

import api from '../plugins/index';
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [api],
  state,
  getters,
  mutations,
  actions,
  modules: {
    authorization,
    files,
    users,
    recipients,
    sms,
    promotions,
  }
})
